import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { InvestmentBuildingsEditorComponent } from '@features/investment/components/investment-buildings-editor.component';
import { FormWizardCustomFieldAdapter } from '@shared/components/form/form-wizard/form-wizard-field-registry.service';
import { FormFieldConfig } from '@shared/components/form/form-wizard/models/form-wizard.models';

@Component({
  selector: 'app-investment-buildings-form-field',
  standalone: true,
  imports: [ReactiveFormsModule, InvestmentBuildingsEditorComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-investment-buildings-editor [formControl]="control" />
  `
})
export class InvestmentBuildingsFormFieldComponent implements FormWizardCustomFieldAdapter {
  @Input({ required: true }) field!: FormFieldConfig;
  @Input({ required: true }) form!: FormGroup;

  get control(): FormControl {
    return this.form.get(this.field.key) as FormControl;
  }
}
